import advertisers from '../api/advertisers'

export default {
    state: {
        advertisers: {},
        filtersData: {},
        advertisersAll: [],
    },
    namespaced: true,
    mutations: {
        async saveAdvertisersStore(state, advertisers) {
            state.advertisers = advertisers
        },
        async setFilterData(state, {key, data}) {
            const filterData = {};
            filterData[key] = data;
            state.filtersData = Object.assign({}, state.filtersData , filterData);
        },
        updateSflAdvertiserStore(state, advertiser) {
            const newData = [...state.advertisers.data];
            const ind = newData.findIndex((adv => adv.id === advertiser.id));
            newData[ind] = {
              ...newData[ind],
              status: advertiser.status,
              name: advertiser.name,
              advertiserManagerId: advertiser.managerId,
              margin: advertiser.margin
            };

            state.advertisers = {
              ...state.advertisers,
              data: newData
            }
        },
        async saveAdvertiserProfileStoreCOWihoutPagination(state, advertisers) {
            state.advertisersAll = advertisers && advertisers.data ? advertisers.data : []
        },
    },
    actions: {
        async getProfiles({commit, dispatch}, data) {
            try {
                commit('saveAdvertisersStore', await advertisers.getAdvertisers(data))
            } catch (err) {
                dispatch('alert/ALERT_ERROR', err.message, {root: true});
            }
        },
        async getFilterData({commit, dispatch}, data) {
            try {
                commit('setFilterData', {key: data.name, data: await advertisers.getFilter(data)})
            } catch (err) {
                dispatch('alert/ALERT_ERROR', err.message, {root: true});
            }
        },
        async updateSflAdvertiser({commit, dispatch}, data) {
            try {
                commit('updateSflAdvertiserStore', await advertisers.updateAdvertiser(data));
                return true;
            } catch (e) {
                dispatch('alert/ALERT_ERROR', err.message, {root: true});
            }
        },
        async getAdvertiserProfileDataCOWithoutPagination({commit, dispatch}, data) {
            try {
                const result = await advertisers.getAdvertisers(data);
                commit('saveAdvertiserProfileStoreCOWihoutPagination', result)
            } catch (err) {
                console.error(err);
                dispatch('alert/ALERT_ERROR', err.message, {root: true});
            }
        },
    },
    getters: {
        profiles: state => state.advertisers,
        filtersData: state => state.filtersData,
        profilesAll: state => state.advertisersAll
    },

}
